/**
 * Configuration service response model.
 *
 * @param {Object} state Data model object
 * @param {string} state.DatabaseName
 * @param {string} state.Server
 * @param {string} state.Username
 */

const response = state => ({
  database: state.DatabaseName,
  server: state.Server,
  username: state.Username,
});

export default {
  response,
};
